export const PUSH_LINK_TO_GLOBAL_STATE = "PUSH_LINK_TO_GLOBAL_STATE";
